// extracted by mini-css-extract-plugin
export default {"chevron":"DetailsButton_chevron__DPlHt","chevron_small":"DetailsButton_chevron_small__Zh2-Y","chevron_up":"DetailsButton_chevron_up__r3AFC"};